<template>
  <div
    v-if="scope.row"
    class="handle-btn"
  >
    <mk-button-biz
      v-if="scope.row.status > 1"
      type="text"
      @click="getStatisticalData(scope.row._id)"
    >
      统计分析
    </mk-button-biz>
    <mk-button-biz
      type="text"
      @click="getDetail(scope.row._id, scope.row.status)"
    >
      {{ scope.row.status === 1 ? '编辑': '详情' }}
    </mk-button-biz>
    <mk-button-biz
      type="text"
      @click="edit(scope.row._id, scope.row.status)"
    >
      {{ scope.row.status === 1 ? '发布' : (scope.row.status === 2 ? '停用' : '启用') }}
    </mk-button-biz>
    <mk-dialog-confirm
      :visible.sync="isShowConfirmDialog"
      v-bind="confirmDialogData"
      append-to-body
      @on-confirm="onConfirm"
    />
  </div>
</template>
<script>
export default {
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isShowConfirmDialog: false,
      confirmDialogData: {},
      isError: false
    }
  },
  methods: {
    getStatisticalData (id) {
      this.$router.push({
        path: '/business-school/learning-task/statistical-data',
        query: {
          id: id
        }
      })
    },
    getDetail (id, status) {
      this.$router.push({
        path: '/business-school/learning-task/task',
        query: {
          edit: true,
          id: id,
          status: status
        }
      })
    },
    edit (id, status) {
      if (status === 1) {
        this.confirmDialogData = {
          title: '发布提示',
          tip: '确认发布该任务吗？',
          iconColor: '#1B9aee',
          iconClass: 'tixing',
          closeBtn: {
            type: 'default',
            color: '#595959',
            text: '取 消',
            isShow: true
          },
          confirmBtn: {
            type: 'primary',
            color: '#fff',
            text: '确认',
            isShow: true
          }
        }
      } else if (status === 2) {
        this.confirmDialogData = {
          title: '停用提示',
          tip: '确认停用该任务吗？',
          iconColor: '#fa8c15',
          iconClass: 'tishi-info',
          closeBtn: {
            type: 'default',
            color: '#595959',
            text: '取 消',
            isShow: true
          },
          confirmBtn: {
            type: 'primary',
            color: '#fff',
            text: '确认',
            isShow: true
          }
        }
      } else if (status === 3) {
        this.confirmDialogData = {
          title: '启用提示',
          tip: '确认启用该任务吗？',
          iconColor: '#fa8c15',
          iconClass: 'tishi-info',
          closeBtn: {
            type: 'default',
            color: '#595959',
            text: '取 消',
            isShow: true
          },
          confirmBtn: {
            type: 'primary',
            color: '#fff',
            text: '确认',
            isShow: true
          }
        }
      }
      this.isShowConfirmDialog = true
    },
    // 发布
    async publish (id) {
      const { success, msg, code } = await MBASVCAPIS.MissionApi.missionPublishPost({
        _id: id
      })
      if (success) {
        if (code === 500200) {
          this.$message({
            type: 'success',
            message: '发布成功',
            showClose: true
          })
          this.$emit('on-publish-click')
          this.isShowConfirmDialog = false
        } else {
          this.isError = true
          this.confirmDialogData = {
            title: '发布失败',
            // tip: msg,
            tip: '任务结束时间不能早于当前时间！',
            iconColor: '#e62412',
            iconClass: 'guanbihuojingshihuocuowu',
            closeBtn: {
              type: 'default',
              color: '#595959',
              text: '取 消',
              isShow: true
            },
            confirmBtn: {
              type: 'primary',
              color: '#fff',
              text: '去编辑',
              isShow: true
            }
          }
        }
      }
      // else {
      //   this.isError = true
      //   this.confirmDialogData = {
      //     title: '发布失败',
      //     // tip: msg,
      //     tip: '任务结束时间不能早于当前时间！',
      //     iconColor: '#e62412',
      //     iconClass: 'guanbihuojingshihuocuowu',
      //     closeBtn: {
      //       type: 'default',
      //       color: '#595959',
      //       text: '取 消',
      //       isShow: true
      //     },
      //     confirmBtn: {
      //       type: 'primary',
      //       color: '#fff',
      //       text: '去编辑',
      //       isShow: true
      //     }
      //   }
      // }
    },
    // 启用，停用
    async enable (id, status) {
      const { success, msg } = await MBASVCAPIS.MissionApi.missionProhibitPost({
        _id: id,
        isProhibit: status === 2
      })
      if (success) {
        this.$message({
          type: 'success',
          message: status === 2 ? '禁用成功' : '启用成功',
          showClose: true
        })
        this.$emit('on-status-click')
        this.isShowConfirmDialog = false
      } else {
        this.$message({
          type: 'error',
          message: msg,
          showClose: true
        })
      }
    },
    // 弹窗确认
    onConfirm () {
      if (!this.isError) {
        let id = this.scope.row._id
        let status = this.scope.row.status
        if (status === 1) {
          this.publish(id)
        } else {
          this.enable(id, status)
        }
      } else {
        this.getDetail(this.scope.row._id, this.scope.status)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .handle-btn {
    display: flex;
    align-items: center;
    // flex-wrap: wrap;

    /deep/ .el-button {
      font-size: 13px !important;

      span {
        font-size: 13px !important;
      }
    }
  }
</style>
